// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.ProfessionalFormActions_save-bar__Z0k9z {
  position: sticky;
  bottom: 20px;
  top: auto;
  z-index: 40;
  box-sizing: border-box;
  width: 100%;
  max-width: 1000px;
  margin: 14px auto 0 0;
  display: block;
  animation: ProfessionalFormActions_slideUp__HsNfQ 0.4s ease-out forwards;
}
.ProfessionalFormActions_save-bar__pill__YYn4Z {
  box-sizing: border-box;
  width: 100%;
  max-width: 1000px;
  min-height: 74px;
  height: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 12px 12px 24px;
  border-radius: 28px;
  background: linear-gradient(90deg, #F8F0D4 0%, #FCF8EA 28%, #F7F5F1 52%, #F7F5F1 100%);
  border: 1px solid rgba(16, 25, 21, 0.08);
  box-shadow: 0 10px 18px rgba(18, 34, 28, 0.1);
}
.ProfessionalFormActions_save-bar__pill--green__rbD8H {
  background: linear-gradient(90deg, #DCEADF 0%, #EAF3ED 28%, #F7F5F1 52%, #F7F5F1 100%);
}
.ProfessionalFormActions_save-bar__state__oL2ym {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.ProfessionalFormActions_save-bar__dot__Uk0a9 {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #D6A640;
  flex: 0 0 10px;
  margin-top: 5px;
  transition: opacity 0.2s ease, background-color 0.2s ease;
}
.ProfessionalFormActions_save-bar__dot--green__kGWa7 {
  background: #82B194;
}
.ProfessionalFormActions_save-bar__dot--saved__Cd60C {
  background: rgba(19, 35, 29, 0.18);
}
.ProfessionalFormActions_save-bar__info__6evux {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.ProfessionalFormActions_save-bar__title__HM8HF {
  font-size: 13px;
  font-weight: 800;
  color: #13231D;
  line-height: 1.25;
  margin-bottom: 2px;
}
.ProfessionalFormActions_save-bar__subtitle__uzudj {
  font-size: 12px;
  color: #6C7771;
  line-height: 1.35;
}
.ProfessionalFormActions_save-bar__actions__a9zrl {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: 104px 148px;
  align-items: stretch;
  gap: 10px;
  flex-wrap: nowrap;
  width: auto;
}
.ProfessionalFormActions_save-bar__btn-exit__r6vNB {
  width: 100%;
  min-width: 0;
  height: 42px;
  min-height: 42px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: transparent;
  border: 1px solid rgba(130, 177, 148, 0.4);
  color: #13231D;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: all 0.2s ease;
}
.ProfessionalFormActions_save-bar__btn-exit__r6vNB:hover {
  background: rgba(130, 177, 148, 0.1);
  border-color: rgba(130, 177, 148, 0.48);
}
.ProfessionalFormActions_save-bar__btn-exit__r6vNB:active {
  transform: translateY(1px);
}
.ProfessionalFormActions_save-bar__btn-save__lKy0z {
  width: 100%;
  min-width: 0;
  height: 42px;
  min-height: 42px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: #82B194;
  color: #ffffff;
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  box-shadow: none;
  transition: all 0.2s ease;
}
.ProfessionalFormActions_save-bar__btn-save__lKy0z:hover:not(:disabled) {
  background: #739F84;
}
.ProfessionalFormActions_save-bar__btn-save__lKy0z:active:not(:disabled) {
  transform: translateY(1px);
}
.ProfessionalFormActions_save-bar__btn-save__lKy0z:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.ProfessionalFormActions_save-bar__btn-save--saved__AfQ\\+z {
  background: rgba(130, 177, 148, 0.16) !important;
  border-color: rgba(130, 177, 148, 0.42) !important;
  color: #294439 !important;
  cursor: default;
}

@keyframes ProfessionalFormActions_slideUp__HsNfQ {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@media (max-width: 820px) {
  .ProfessionalFormActions_save-bar__Z0k9z {
    position: fixed;
    bottom: 16px;
    left: 14px;
    right: 14px;
    width: auto;
    max-width: none;
    margin: 0;
    z-index: 1000;
    pointer-events: auto;
  }
  .ProfessionalFormActions_save-bar__pill__YYn4Z {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    border-radius: 20px;
    gap: 10px;
    min-height: unset;
    box-shadow: 0 14px 34px rgba(18, 34, 28, 0.24);
  }
  .ProfessionalFormActions_save-bar__state__oL2ym {
    align-items: center;
    gap: 8px;
  }
  .ProfessionalFormActions_save-bar__dot__Uk0a9 {
    margin-top: 0;
  }
  .ProfessionalFormActions_save-bar__subtitle__uzudj {
    display: none;
  }
  .ProfessionalFormActions_save-bar__title__HM8HF {
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0;
  }
  .ProfessionalFormActions_save-bar__actions__a9zrl {
    flex: 0 0 auto;
    width: auto;
    display: flex;
    gap: 8px;
  }
  .ProfessionalFormActions_save-bar__btn-exit__r6vNB {
    width: auto;
    padding: 0 14px;
    height: 38px;
    min-height: 38px;
    font-size: 12px;
  }
  .ProfessionalFormActions_save-bar__btn-save__lKy0z {
    width: auto;
    padding: 0 18px;
    height: 38px;
    min-height: 38px;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/EditProfileProfessional/components/FormActions/ProfessionalFormActions.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AANA;EACI,gBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,wEAAA;AASJ;AAPI;EACI,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,4BAAA;EACA,mBAAA;EACA,sFAAA;EACA,wCAAA;EACA,6CA9Ba;AAuCrB;AAPQ;EACI,sFAAA;AASZ;AALI;EACI,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAOR;AAJI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;AAMR;AAJQ;EACI,mBA5DC;AAkEb;AAHQ;EACI,kCAAA;AAKZ;AADI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAGR;AAAI;EACI,eAAA;EACA,gBAAA;EACA,cA3EE;EA4EF,iBAAA;EACA,kBAAA;AAER;AACI;EACI,eAAA;EACA,cAjFG;EAkFH,iBAAA;AACR;AAEI;EACI,cAAA;EACA,aAAA;EACA,kCAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;AAAR;AAGI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,cA5GE;EA6GF,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;AADR;AAGQ;EACI,oCAAA;EACA,uCAAA;AADZ;AAIQ;EACI,0BAAA;AAFZ;AAMI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBA1IK;EA2IL,cAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAJR;AAMQ;EACI,mBArJO;AAiJnB;AAOQ;EACI,0BAAA;AALZ;AAQQ;EACI,YAAA;EACA,mBAAA;AANZ;AASQ;EACI,gDAAA;EACA,kDAAA;EACA,yBAAA;EACA,eAAA;AAPZ;;AAYA;EACI;IAAO,2BAAA;IAA6B,UAAA;EAPtC;EAQE;IAAK,wBAAA;IAA0B,UAAA;EAJjC;AACF;AAMA;EACI;IACI,eAAA;IACA,YAAA;IACA,UAAA;IACA,WAAA;IACA,WAAA;IACA,eAAA;IACA,SAAA;IACA,aAAA;IACA,oBAAA;EAJN;EAMM;IACI,mBAAA;IACA,mBAAA;IACA,8BAAA;IACA,kBAAA;IACA,mBAAA;IACA,SAAA;IACA,iBAAA;IACA,8CAAA;EAJV;EAOM;IACI,mBAAA;IACA,QAAA;EALV;EAQM;IACI,aAAA;EANV;EASM;IACI,aAAA;EAPV;EAUM;IACI,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;EARV;EAWM;IACI,cAAA;IACA,WAAA;IACA,aAAA;IACA,QAAA;EATV;EAYM;IACI,WAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;EAVV;EAaM;IACI,WAAA;IACA,eAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;EAXV;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../../assets/styles/variables';\n\n$bw-surface: #F7F5F1;\n$bw-primary: #82B194;\n$bw-primary-hover: #739F84;\n$bw-text: #13231D;\n$bw-muted: #6C7771;\n$bw-border: rgba(16, 25, 21, 0.08);\n$bw-shadow-floating: 0 10px 18px rgba(18, 34, 28, 0.10);\n\n.save-bar {\n    position: sticky;\n    bottom: 20px;\n    top: auto;\n    z-index: 40;\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 1000px;\n    margin: 14px auto 0 0;\n    display: block;\n    animation: slideUp 0.4s ease-out forwards;\n\n    &__pill {\n        box-sizing: border-box;\n        width: 100%;\n        max-width: 1000px;\n        min-height: 74px;\n        height: auto;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        align-items: center;\n        justify-content: space-between;\n        gap: 14px;\n        padding: 12px 12px 12px 24px;\n        border-radius: 28px;\n        background: linear-gradient(90deg, #F8F0D4 0%, #FCF8EA 28%, #F7F5F1 52%, #F7F5F1 100%);\n        border: 1px solid $bw-border;\n        box-shadow: $bw-shadow-floating;\n        \n        &--green {\n            background: linear-gradient(90deg, #DCEADF 0%, #EAF3ED 28%, #F7F5F1 52%, #F7F5F1 100%);\n        }\n    }\n\n    &__state {\n        flex: 1 1 auto;\n        min-width: 0;\n        display: flex;\n        align-items: flex-start;\n        gap: 12px;\n    }\n\n    &__dot {\n        width: 10px;\n        height: 10px;\n        border-radius: 50%;\n        background: #D6A640;\n        flex: 0 0 10px;\n        margin-top: 5px;\n        transition: opacity 0.2s ease, background-color 0.2s ease;\n\n        &--green {\n            background: $bw-primary;\n        }\n\n        &--saved {\n            background: rgba(19, 35, 29, 0.18);\n        }\n    }\n\n    &__info {\n        display: flex;\n        flex-direction: column;\n        min-width: 0;\n    }\n\n    &__title {\n        font-size: 13px;\n        font-weight: 800;\n        color: $bw-text;\n        line-height: 1.25;\n        margin-bottom: 2px;\n    }\n\n    &__subtitle {\n        font-size: 12px;\n        color: $bw-muted;\n        line-height: 1.35;\n    }\n\n    &__actions {\n        flex: 0 0 auto;\n        display: grid;\n        grid-template-columns: 104px 148px;\n        align-items: stretch;\n        gap: 10px;\n        flex-wrap: nowrap;\n        width: auto;\n    }\n\n    &__btn-exit {\n        width: 100%;\n        min-width: 0;\n        height: 42px;\n        min-height: 42px;\n        padding: 0 10px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 14px;\n        background: transparent;\n        border: 1px solid rgba(130, 177, 148, 0.40);\n        color: $bw-text;\n        font-size: 13px;\n        font-weight: 800;\n        cursor: pointer;\n        font-family: inherit;\n        white-space: nowrap;\n        transition: all 0.2s ease;\n\n        &:hover {\n            background: rgba(130, 177, 148, 0.10);\n            border-color: rgba(130, 177, 148, 0.48);\n        }\n\n        &:active {\n            transform: translateY(1px);\n        }\n    }\n\n    &__btn-save {\n        width: 100%;\n        min-width: 0;\n        height: 42px;\n        min-height: 42px;\n        padding: 0 10px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 14px;\n        background: $bw-primary;\n        color: #ffffff;\n        border: 1px solid transparent;\n        font-size: 13px;\n        font-weight: 800;\n        cursor: pointer;\n        font-family: inherit;\n        white-space: nowrap;\n        box-shadow: none;\n        transition: all 0.2s ease;\n\n        &:hover:not(:disabled) {\n            background: $bw-primary-hover;\n        }\n\n        &:active:not(:disabled) {\n            transform: translateY(1px);\n        }\n\n        &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n        }\n\n        &--saved {\n            background: rgba(130, 177, 148, 0.16) !important;\n            border-color: rgba(130, 177, 148, 0.42) !important;\n            color: #294439 !important;\n            cursor: default;\n        }\n    }\n}\n\n@keyframes slideUp {\n    from { transform: translateY(30px); opacity: 0; }\n    to { transform: translateY(0); opacity: 1; }\n}\n\n@media (max-width: 820px) {\n    .save-bar {\n        position: fixed;\n        bottom: 16px;\n        left: 14px;\n        right: 14px;\n        width: auto;\n        max-width: none;\n        margin: 0;\n        z-index: 1000;\n        pointer-events: auto;\n\n        &__pill {\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-between;\n            padding: 10px 14px;\n            border-radius: 20px;\n            gap: 10px;\n            min-height: unset;\n            box-shadow: 0 14px 34px rgba(18, 34, 28, 0.24);\n        }\n\n        &__state {\n            align-items: center;\n            gap: 8px;\n        }\n\n        &__dot {\n            margin-top: 0;\n        }\n\n        &__subtitle {\n            display: none;\n        }\n\n        &__title {\n            font-size: 13px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            margin-bottom: 0;\n        }\n\n        &__actions {\n            flex: 0 0 auto;\n            width: auto;\n            display: flex;\n            gap: 8px;\n        }\n\n        &__btn-exit {\n            width: auto;\n            padding: 0 14px;\n            height: 38px;\n            min-height: 38px;\n            font-size: 12px;\n        }\n\n        &__btn-save {\n            width: auto;\n            padding: 0 18px;\n            height: 38px;\n            min-height: 38px;\n            font-size: 12px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"save-bar": `ProfessionalFormActions_save-bar__Z0k9z`,
	"slideUp": `ProfessionalFormActions_slideUp__HsNfQ`,
	"save-bar__pill": `ProfessionalFormActions_save-bar__pill__YYn4Z`,
	"save-bar__pill--green": `ProfessionalFormActions_save-bar__pill--green__rbD8H`,
	"save-bar__state": `ProfessionalFormActions_save-bar__state__oL2ym`,
	"save-bar__dot": `ProfessionalFormActions_save-bar__dot__Uk0a9`,
	"save-bar__dot--green": `ProfessionalFormActions_save-bar__dot--green__kGWa7`,
	"save-bar__dot--saved": `ProfessionalFormActions_save-bar__dot--saved__Cd60C`,
	"save-bar__info": `ProfessionalFormActions_save-bar__info__6evux`,
	"save-bar__title": `ProfessionalFormActions_save-bar__title__HM8HF`,
	"save-bar__subtitle": `ProfessionalFormActions_save-bar__subtitle__uzudj`,
	"save-bar__actions": `ProfessionalFormActions_save-bar__actions__a9zrl`,
	"save-bar__btn-exit": `ProfessionalFormActions_save-bar__btn-exit__r6vNB`,
	"save-bar__btn-save": `ProfessionalFormActions_save-bar__btn-save__lKy0z`,
	"save-bar__btn-save--saved": `ProfessionalFormActions_save-bar__btn-save--saved__AfQ+z`
};
export default ___CSS_LOADER_EXPORT___;
